import InnerPage from "../components/InnerPage";
import PageBanner from "../components/PageBanner";
import {
  aboutIntro,
  company,
  cultureCards,
  shareholders,
  teamText,
  timeline,
} from "../data/site";

const tabs = [
  { id: "tab1", label: "公司简介" },
  { id: "tab2", label: "文化及价值观" },
  { id: "tab3", label: "股东背景" },
  { id: "tab4", label: "管理团队" },
  { id: "tab5", label: "大事记" },
];

export default function About() {
  return (
    <InnerPage
      banner={<PageBanner title="关于我们" en="ABOUT US" variant="about" />}
      tabs={tabs}
    >
      <section id="tab1" className="panel">
        <div className="container">
          <h2 className="small-title">公司简介</h2>
          <div className="split">
            <div className="prose">
              {aboutIntro.map((p) => (
                <p key={p.slice(0, 12)}>{p}</p>
              ))}
              <ul className="fact-list">
                <li>
                  <span>成立日期</span>
                  <b>{company.founded}</b>
                </li>
                <li>
                  <span>统一社会信用代码</span>
                  <b>{company.creditCode}</b>
                </li>
                <li>
                  <span>注册资本</span>
                  <b>{company.capital}</b>
                </li>
                <li>
                  <span>所属行业</span>
                  <b>{company.industry}</b>
                </li>
              </ul>
            </div>
            <aside className="portrait-card tone-ocean">
              <div className="portrait-art" />
              <div>
                <h3>{company.shortName}</h3>
                <p>海南自由贸易港 · 三亚</p>
                <p>{company.address}</p>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <section id="tab2" className="panel">
        <div className="container">
          <h2 className="small-title">文化及价值观</h2>
          <div className="culture-grid">
            {cultureCards.map((card) => (
              <article className="culture-card" key={card.title}>
                <h3>{card.title}</h3>
                <p>{card.content}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section id="tab3" className="panel">
        <div className="container">
          <h2 className="small-title">股东背景</h2>
          <p className="panel-lead">
            文趣互动由{company.parent}100% 持股，承接开普云、博瑞传播与成都文交所共同构筑的文化元宇宙产业背景。
          </p>
          <div className="share-grid">
            {shareholders.map((item) => (
              <article className="share-card" key={item.name}>
                <p className="tag">{item.role}</p>
                <h3>{item.name}</h3>
                {item.code && <p className="code">{item.code}</p>}
                {item.stake && <p className="stake">{item.stake}</p>}
                <p>{item.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section id="tab4" className="panel">
        <div className="container">
          <h2 className="small-title">管理团队</h2>
          <div className="split">
            <aside className="portrait-card tone-team">
              <div className="portrait-art" />
              <div>
                <h3>核心团队</h3>
                <p>法定代表人：{company.legalRep}</p>
                <p>承接文趣星球与开普云数字文旅板块的产品、技术与运营能力。</p>
              </div>
            </aside>
            <div className="prose">
              {teamText.map((p) => (
                <p key={p.slice(0, 16)}>{p}</p>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section id="tab5" className="panel">
        <div className="container">
          <h2 className="small-title">大事记</h2>
          <ol className="timeline">
            {timeline.map((item, index) => (
              <li key={item.title}>
                <div className="tl-index">{String(index + 1).padStart(2, "0")}</div>
                <div className="tl-card">
                  <div className="tl-cover tone-ocean">
                    <span>{item.date}</span>
                  </div>
                  <div>
                    <h3>{item.title}</h3>
                    <p>{item.content}</p>
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>
    </InnerPage>
  );
}
